var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.2163V15.1863C2.5 20.1863 4.5 22.1863 9.5 22.1863H15.5C20.5 22.1863 22.5 20.1863 22.5 15.1863V9.18628C22.5 4.18628 20.5 2.18628 15.5 2.18628H9.5C4.5 2.18628 2.5 4.18628 2.5 9.18628",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.6863C12.9596 15.6863 13.4148 15.5957 13.8394 15.4199C14.264 15.244 14.6499 14.9862 14.9749 14.6612C15.2999 14.3361 15.5577 13.9503 15.7336 13.5257C15.9095 13.101 16 12.6459 16 12.1863C16 11.7267 15.9095 11.2715 15.7336 10.8469C15.5577 10.4222 15.2999 10.0364 14.9749 9.71141C14.6499 9.3864 14.264 9.12859 13.8394 8.9527C13.4148 8.77681 12.9596 8.68628 12.5 8.68628C11.5717 8.68628 10.6815 9.05503 10.0251 9.71141C9.36875 10.3678 9 11.258 9 12.1863C9 13.1145 9.36875 14.0048 10.0251 14.6612C10.6815 15.3175 11.5717 15.6863 12.5 15.6863Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1367 7.18628H18.1486",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c3adbea0646cbb4a4f8b3eb5f935c95e.svg";
export { ForwardRef as ReactComponent };